export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10826.324dac33.jpg";